import { ClubScreenQueryRenderer } from "./ClubScreenQueryRenderer";

export const ClubScreen = () => {
  return <ClubScreenQueryRenderer />;
};
